import { useEffect, useState } from "react";
import CardC from "../../../components/CustomCard/CardC";
import Datatable from "../../../components/Datatable/Datatable";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Loader, toaster } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import { Button } from "react-bootstrap";
import createURL from "../../../libs/peticiones/url";
import Form from "./Form";
import { Usuario } from "../../../types/admin-usuarios/Usuario";
import { useStore } from "../../../context/AppContext";
import { checkPermission } from "../../../libs/menuPermissions/permissions";
import { System } from "../../../types/admin-usuarios/System";

export default function Usuarios() {
  const [loading, setLoading] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [selected, setSelected] = useState<Usuario | undefined>();
  const { state } = useStore();

  async function getData(
    order: string,
    records: number,
    page: number,
    search: string
  ) {
    const url = createURL("/usuarios", [
      { name: "order", value: order },
      { name: "records", value: records },
      { name: "page", value: page },
      { name: "search", value: search },
      { name: "populate", value: "system" },
    ]);
    const res = await peticionBack({}, url, "GET", false, toaster);
    return res;
  }

  /* TABLA */
  const columns = [
    { data: "fullname" },
    {
      data: "email",
      render: (d: string) => (
        <a href={`mailto:${d}`} type="e">
          {d}
        </a>
      ),
    },
    {
      data: "phone",
      render: (d: string) => (
        <a href={`tel:${d}p000`} type="e">
          {d}
        </a>
      ),
    },
    {
      data: "system",
      render: (d: System) => (
        <a href={`tel:${d}p000`} type="e">
          {d.name}
        </a>
      ),
    },
    {
      data: null,
      render: (row: Usuario) => (
        <div className="d-flex justify-content-evenly">
          {checkPermission(state, "update") && (
            <FontAwesomeIcon
              icon={faPencil}
              className="text-warning cursor-pointer"
              onClick={() => openToEdit(row)}
            />
          )}
          {checkPermission(state, "delete") && (
            <FontAwesomeIcon
              icon={faTrashCan}
              className="text-danger cursor-pointer"
              onClick={() =>
                swalAction(
                  deleteRow,
                  "Eliminar usuario",
                  `¿Desea eliminar el usuario ${row.fullname}?`,
                  "question",
                  row._id,
                  "Eliminar"
                )
              }
            />
          )}
        </div>
      ),
    },
  ];

  const columnDefs = [
    { orderable: false, targets: [4] },
    { className: "text-center", targets: [0, 1, 2] },
  ];

  async function deleteRow(id: string) {
    setLoading(true);
    const res = await peticionBack(
      {},
      `/usuarios/${id}`,
      "DELETE",
      true,
      toaster
    );
    if (res) setRefresh(true);
    setLoading(false);
  }

  function openToEdit(row: Usuario) {
    if (row.phone.startsWith("+52")) {
      row.phone = row.phone.substring(3);
    }
    setSelected(row);
  }

  useEffect(() => {
    if (selected) setOpen(true);
  }, [selected]);

  useEffect(() => {
    if (!open) {
      setSelected(undefined);
    }
  }, [open]);

  return (
    <CardC>
      <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
        <h4 className="">
          Usuarios {open && (selected ? "- Editar" : "- Agregar")}
        </h4>
        {!open && checkPermission(state, "create") && (
          <Button onClick={() => setOpen(true)} className="my-1 my-md-0">
            Agregar
          </Button>
        )}
      </div>
      {open ? (
        <Form setOpen={setOpen} selected={selected} />
      ) : (
        checkPermission(state, "read") && (
          <Datatable
            columns={columns}
            headers={[
              "Nombre",
              "Correoe Electrónico",
              "Teléfono",
              "Systema",
              "Acciones",
            ]}
            columnDefs={columnDefs}
            petition={getData}
            control="back"
            stateRefresh={[refresh, setRefresh]}
            className="p-0"
          />
        )
      )}
      {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
    </CardC>
  );
}
